<template>
  <div class="ShareResumeModal pt-4 pb-4">
    <BasePreloader v-if="loading" />

    <div class="pl-5 pr-5">
      <h1>{{ $tMyResponses('Share resume') }}</h1>

      <div class="copy-value">
        <span class="copy-value__val">{{ shareResumeUrl }}</span>
        <div class="copy-value__btn-wrap">
          <div class="small-tooltip" :class="{'_show': showCopyTooltip}">
            <BaseSvg name="ico-check"/>
            <span>{{ $tResumesBaseInviteModal('Link copied') }}</span>
          </div>
          <button type="button"
                  class="copy-value__btn base-btn base-btn--blue base-btn--small"
                  @click.prevent="onCopy(shareResumeUrl)">
            <BaseSvg name="ico-copy"
                     width="1.2rem"
                     height="1.3rem"/>
            <span>{{ $tResumesBaseInviteModal('Copy') }}</span>
          </button>
        </div>
      </div>
    </div>

    <div style="border-bottom: .1rem solid #e3e8ed;" class="mt-5"></div>

    <div class="pl-5 pr-5">
      <div class="invite-popup__field _blue mt-5">
        <h4 class="invite-popup__field-title">
          Email
        </h4>
        <div class="invite-popup__field-group">
          <div class="invite-popup__field-label">{{ $tMyResponses('Specify the candidate email') }}</div>
          <div class="invite-popup__field-input">
            <BaseInput
              v-model="email"
              label="Email"
              type="email"
              :error="error"
              class="mt-5"
            />
            <div class="invite-popup__field-btn-wrap">
              <div class="d-flex justify-between items-center mt-5">
                <button
                  class="base-btn base-btn--blue mt-5"
                  @click="submit"
                >
                  {{ $tVacancy('Submit') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ShareToMessengers
        :title="$tMyResponses('Share in messengers')"
        :custom-link="shareResumeUrl"
        class="mt-5 mb-1"
      />
    </div>
  </div>
</template>

<script>
import ShareToMessengers from './ShareToMessengers';
import { http } from '../axios';

let timerCopy = null;

export default {
  name: 'ShareResumeModal',
  components: {
    ShareToMessengers,
  },
  props: {
    resumeId: {
      type: Number,
      default: 0,
    },
    resume: {
      type: Object,
      default: () => ({}),
    },
    modalName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: '',
      loading: false,
      error: null,
      showCopyTooltip: false,
    };
  },
  computed: {
    shareResumeUrl() {
      return this.resume.share_url;
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        const { data } = await http.post('/api/cabinet/share-resume-email', {
          send_resume_id: this.resumeId,
          email: this.email,
        });
        if (data.data) this.close();
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$vModal.close(this.modalName);
    },
    onCopy(text) {
      navigator.clipboard.writeText(text)
      this.showCopyTooltip = true

      clearTimeout(timerCopy)
      timerCopy = setTimeout(() => {
        this.showCopyTooltip = false
      }, 3000)
    },
  },
};
</script>
